import {
  FaSignOutAlt,
  FaHome,
  FaComments,
  FaUserTie,
  FaUserCircle,
  FaComment,
} from "react-icons/fa";
import styles from "./SideMenu.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { PROFILE_PICTURE } from "../../common/constants";

const SideMenu = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("photoURL");
    navigate({
      pathname: "/",
    });
    window.location.reload();
  };

  const home = () => {
    navigate({
      pathname: "/",
    });
  };
  return (
    <section className={styles.container}>
      <article>
        {PROFILE_PICTURE ? (
          <img src={PROFILE_PICTURE as string} width={45} height={45} />
        ) : (
          <div className={styles.navBox}>
            <FaUserCircle size={31} />
          </div>
        )}
      </article>
      <article className={styles.mobileFlexCenter}>
        <div
          className={`${styles.navBox} ${window.location.pathname === "/chat" && styles.bgBlue}`}
        >
          <Link to={"/chat"}>
            <FaComment size={31} />
          </Link>
        </div>
        <div
          className={`${styles.navBox} ${window.location.pathname === "/compare" && styles.bgBlue}`}
        >
          <Link to={"/compare"}>
            <FaComments size={31} />
          </Link>
        </div>
        <div className={styles.navBox} onClick={home}>
          <FaHome size={31} />
        </div>

        {window.location.pathname === "/admin" && (
          <div
            className={`${styles.navBox} ${window.location.pathname === "/admin" && styles.bgBlue}`}
          >
            <Link to={"/admin"}>
              <FaUserTie size={31} />
            </Link>
          </div>
        )}
      </article>

      <article>
        <div onClick={logout} className={styles.navBox}>
          <FaSignOutAlt size={31} />
        </div>
      </article>
    </section>
  );
};

export default SideMenu;
